import { defaultShouldDehydrateQuery, isServer, QueryClient } from '@tanstack/react-query'
import { reportError } from './reportError'
import { PostgrestError } from '@supabase/supabase-js'
function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // With SSR, we usually want to set some default staleTime
        // above 0 to avoid refetching immediately on the client
        staleTime: 60 * 1000,
        gcTime: 1000 * 60 * 60 * 24, // 24 hours
        retry: (failureCount, error) => {
          if (error instanceof PostgrestError) {
            // PGRST116: single row requested, but multiple rows or no rows returned
            // Effectively a 404, but postgrest calls this a 406
            if (error.code === 'PGRST116') {
              return false
            }
          }

          return failureCount < 3
        }
      },
      mutations: {
        onError: (error, _variables, _context) => {
          reportError(error)
        }
      },
      dehydrate: {
        // include pending queries in dehydration
        shouldDehydrateQuery: (query) =>
          defaultShouldDehydrateQuery(query) ||
          query.state.status === 'pending',
        shouldRedactErrors: (_) => {
          // We should not catch Next.js server errors
          // as that's how Next.js detects dynamic pages
          // so we cannot redact them.
          // Next.js also automatically redacts errors for us
          // with better digests.
          return false
        },
      },
    },
  })
}

let browserQueryClient: QueryClient | undefined = undefined

export function getQueryClient() {
  if (isServer) {
    // Server: always make a new query client
    // TODO: Why ^ ? if we only had one and memoized it, we could call this from multiple levels
    return makeQueryClient()
  } else {
    // Browser: make a new query client if we don't already have one
    // This is very important, so we don't re-make a new client if React
    // suspends during the initial render. This may not be needed if we
    // have a suspense boundary BELOW the creation of the query client
    if (!browserQueryClient) browserQueryClient = makeQueryClient()
    return browserQueryClient
  }
}
